if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.productId = this.dataset.productId;
      this.form = this.querySelector('form');
      if(this.form){
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton?.querySelector('span');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      this.fetchQuantityRules();
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
    }

    fetchQuantityRules(evt) {
      const container = this.closest('product-info') || this;

      if ((evt && evt.productId && evt.productId.toString() !== this.productId) || !container) return;

      fetch(container.dataset.url).then((response) => {
        return response.text()
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        this.updateSubmitButton(container, html);
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {});
    }

    updateSubmitButton(container, html) {
      let maxQuantityReached = false;    
      const productElement = html.querySelector('section[id^="MainProduct-"]');  
      const sectionId = productElement?.dataset.section;
      const quantityFormUpdated = productElement?.querySelector(`#Quantity-Form-${sectionId}`);
      const quantityInput = quantityFormUpdated?.querySelector('.quantity__input');

      if (!quantityInput || !this.submitButton) return;

      const data = {
        cartQuantity: quantityInput.dataset.cartQuantity ? parseInt(quantityInput.dataset.cartQuantity) : 0,
        max: quantityInput.dataset.max ? parseInt(quantityInput.dataset.max) : null
      }

      const max = data.max === null ? null : data.max;

      if (max !== null) maxQuantityReached = data.cartQuantity >= max;

      if (maxQuantityReached) {
        container.classList.add('max-quantity-reached');
        this.submitButton.disabled = true;
        this.submitButtonText.textContent = window.variantStrings.maxQuantity;
        this.updateWishlistButton(container, maxQuantityReached);
        this.dispatchEvent(new CustomEvent('max-quantity-reached', {
          bubbles: true,
          detail: {
            maxQuantityReached: true,
            productId: this.productId
          }
        }));
      }
    }

    updateWishlistButton(container, maxQuantityReached) {
      waitForElement('wishlist-button-block').then(() => {
        const wishlistButton = container.querySelector('wk-button .wk-button');
        if (!wishlistButton) return;
        if (maxQuantityReached) {
          if (wishlistButton.classList.contains('wk-selected')) wishlistButton.click();
          wishlistButton.remove();
        }
      });
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      evt.stopPropagation();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, { source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), productId: this.productId });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }

          this.scrollToAfterGiftAddFromCart()
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    scrollToAfterGiftAddFromCart() {
      if (this.getAttribute('data-gift-from-cart') === ""){
        setTimeout(() => {
          document.querySelector('cart-items')?.scrollIntoView({ behavior: 'smooth' });
        }, 1000);
      }
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
